import { render, staticRenderFns } from "./OLSStep.vue?vue&type=template&id=1ef535c6&scoped=true&"
import script from "./OLSStep.vue?vue&type=script&lang=js&"
export * from "./OLSStep.vue?vue&type=script&lang=js&"
import style0 from "./OLSStep.vue?vue&type=style&index=0&id=1ef535c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef535c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
